module.exports = __webpack_public_path__ + "366193024897bfd37aa3bf4aeb16f9a2.svg";